import type { ReactNode } from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';
import { Badge } from '@/components/ui/badge';

export function SidebarCollapsible({
  title,
  badge,
  defaultOpen = false,
  children,
}: {
  title: string;
  badge?: string;
  defaultOpen?: boolean;
  children: ReactNode;
}) {
  return (
    <Accordion
      type="single"
      collapsible
      defaultValue={defaultOpen ? title : undefined}
      className="bg-background/40 rounded-lg border"
    >
      <AccordionItem value={title} className="border-b-0">
        <AccordionTrigger className="text-foreground px-3 py-2.5 text-sm font-medium hover:no-underline">
          <span className="flex min-w-0 items-center gap-2">
            <span className="truncate">{title}</span>
            {badge ? (
              <Badge variant="secondary" className="text-muted-foreground shrink-0 rounded-full text-[10px] font-normal">
                {badge}
              </Badge>
            ) : null}
          </span>
        </AccordionTrigger>
        <AccordionContent className="border-border border-t px-3 pb-3 pt-2">{children}</AccordionContent>
      </AccordionItem>
    </Accordion>
  );
}
